/**
 * M-01 문자 보내기 수신자 및 촬영 선택 팝업 전용 비식별 Mock입니다.
 * 이 파일의 값은 API, 데이터베이스, 문자 발송 서비스와 연결되지 않습니다.
 */

export type LegacySmsRecipientMode = 'customer' | 'shoot' | 'phone'
export type LegacySmsContactKind = 'mother' | 'father' | 'direct'

export const legacySmsFilmingStatusOptions = [
  { code: '0', label: '미완료' },
  { code: '1', label: '완료' },
  { code: '2', label: '연기' },
  { code: '3', label: '취소' },
  { code: '4', label: '변경' },
  { code: '5', label: '노쇼' },
  { code: '6', label: '2주' },
  { code: '7', label: 'OK' },
] as const

export type LegacySmsFilmingStatusCode = (typeof legacySmsFilmingStatusOptions)[number]['code']

function legacySmsMockDate(offsetDays = 0) {
  const date = new Date()
  date.setHours(12, 0, 0, 0)
  date.setDate(date.getDate() + offsetDays)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export type LegacySmsContact = {
  id: string
  kind: LegacySmsContactKind
  relation: string
  name: string
  phone: string
  defaultChecked: boolean
}

export type LegacySmsRecipientRow = {
  id: string
  mode: LegacySmsRecipientMode
  customerNo: string
  babyName: string
  oopsId: string
  source: string
  hospital: string
  postnatalCare: string
  additionalSource1: string
  additionalSource2: string
  contacts: LegacySmsContact[]
  scheduleId?: string
  scheduleDate?: string
  photoStart?: string
  photoEnd?: string
  scheduleTitle?: string
}

export type LegacySmsFilmingRow = {
  id: string
  customerId: string
  statusCode: LegacySmsFilmingStatusCode
  scheduleDate: string
  photoStart: string
  photoEnd: string
  scheduleTitle: string
  productType: '촬영' | '메이크업' | '의상대여'
  contractType: '계약' | '미계약'
  customerNo: string
  babyName: string
  motherName: string
  motherPhone: string
  fatherName: string
  fatherPhone: string
  source: string
  hospital: string
  postnatalCare: string
  additionalSource1: string
  additionalSource2: string
}

export const LEGACY_SMS_CUSTOMER_SELECTION = 'legacy-sms-customer-selection'
export const LEGACY_SMS_SHOOT_SELECTION = 'legacy-sms-shoot-selection'

export type LegacySmsPopupSelectionMessage =
  | { type: typeof LEGACY_SMS_CUSTOMER_SELECTION; recipients: LegacySmsRecipientRow[] }
  | { type: typeof LEGACY_SMS_SHOOT_SELECTION; recipients: LegacySmsRecipientRow[] }

export const legacySmsRecipientRows: LegacySmsRecipientRow[] = [
  {
    id: 'mock-sms-customer-001', mode: 'customer', customerNo: 'C-MOCK-001', babyName: 'Mock 아기 01', oopsId: 'MOCK-OOPS-001',
    source: 'Mock 온라인', hospital: 'Mock 산부인과 01', postnatalCare: 'Mock 조리원 01', additionalSource1: 'Mock 추가경로 01', additionalSource2: '-',
    contacts: [
      { id: 'mock-sms-customer-001-mother', kind: 'mother', relation: '(엄마)', name: 'Mock 보호자 A', phone: '010-0000-0101', defaultChecked: true },
      { id: 'mock-sms-customer-001-father', kind: 'father', relation: '(아빠)', name: 'Mock 보호자 B', phone: '010-0000-0102', defaultChecked: false },
    ],
  },
  {
    id: 'mock-sms-customer-002', mode: 'customer', customerNo: 'C-MOCK-002', babyName: 'Mock 아기 02', oopsId: 'MOCK-OOPS-002',
    source: 'Mock 소개', hospital: '-', postnatalCare: 'Mock 조리원 02', additionalSource1: '-', additionalSource2: 'Mock 추가경로 02',
    contacts: [
      { id: 'mock-sms-customer-002-father', kind: 'father', relation: '(아빠)', name: 'Mock 보호자 C', phone: '010-0000-0202', defaultChecked: true },
    ],
  },
  {
    id: 'mock-sms-customer-003', mode: 'customer', customerNo: 'C-MOCK-003', babyName: 'Mock 아기 03', oopsId: 'MOCK-OOPS-003',
    source: 'Mock 검색', hospital: 'Mock 산부인과 03', postnatalCare: '-', additionalSource1: '-', additionalSource2: '-',
    contacts: [
      { id: 'mock-sms-customer-003-mother', kind: 'mother', relation: '(엄마)', name: 'Mock 보호자 D', phone: '010-0000-0301', defaultChecked: true },
    ],
  },
]

export const legacySmsFilmingRows: LegacySmsFilmingRow[] = [
  {
    id: 'mock-shoot-001', customerId: 'mock-sms-customer-001', statusCode: '0', scheduleDate: legacySmsMockDate(), photoStart: '10:00', photoEnd: '11:00', scheduleTitle: 'Mock 촬영상품 01', productType: '촬영', contractType: '계약',
    customerNo: 'C-MOCK-001', babyName: 'Mock 아기 01', motherName: 'Mock 보호자 A', motherPhone: '010-0000-0101', fatherName: 'Mock 보호자 B', fatherPhone: '010-0000-0102',
    source: 'Mock 온라인', hospital: 'Mock 산부인과 01', postnatalCare: 'Mock 조리원 01', additionalSource1: 'Mock 추가경로 01', additionalSource2: '-',
  },
  {
    id: 'mock-shoot-002', customerId: 'mock-sms-customer-004', statusCode: '1', scheduleDate: legacySmsMockDate(), photoStart: '13:30', photoEnd: '14:30', scheduleTitle: 'Mock 촬영상품 02', productType: '촬영', contractType: '미계약',
    customerNo: 'C-MOCK-004', babyName: 'Mock 아기 04', motherName: 'Mock 보호자 E', motherPhone: '010-0000-0401', fatherName: '', fatherPhone: '',
    source: 'Mock 소개', hospital: '-', postnatalCare: 'Mock 조리원 04', additionalSource1: '-', additionalSource2: '-',
  },
  {
    id: 'mock-shoot-003', customerId: 'mock-sms-customer-005', statusCode: '2', scheduleDate: legacySmsMockDate(1), photoStart: '09:00', photoEnd: '10:30', scheduleTitle: 'Mock 메이크업 01', productType: '메이크업', contractType: '계약',
    customerNo: 'C-MOCK-005', babyName: 'Mock 아기 05', motherName: '', motherPhone: '', fatherName: 'Mock 보호자 F', fatherPhone: '010-0000-0502',
    source: 'Mock 검색', hospital: 'Mock 산부인과 05', postnatalCare: '-', additionalSource1: '-', additionalSource2: 'Mock 추가경로 05',
  },
]

export const legacySmsFilmingOptions = {
  offices: ['Mock 지점 A', 'Mock 지점 B'],
  productTypes: ['전체', '촬영', '메이크업', '의상대여'],
  contractTypes: ['전체', '계약', '미계약'],
  products: ['Mock 촬영상품 01', 'Mock 촬영상품 02', 'Mock 메이크업 01'],
  statusOptions: legacySmsFilmingStatusOptions,
  pageLimits: [30, 60, 100, 500, 1000],
} as const

export function filmingRowToSmsRecipient(row: LegacySmsFilmingRow): LegacySmsRecipientRow {
  const contacts: LegacySmsContact[] = []
  if (row.motherPhone) contacts.push({ id: `${row.id}-mother`, kind: 'mother', relation: '(엄마)', name: row.motherName, phone: row.motherPhone, defaultChecked: true })
  if (row.fatherPhone) contacts.push({
    id: `${row.id}-father`, kind: 'father', relation: '(아빠)', name: row.fatherName, phone: row.fatherPhone,
    defaultChecked: !row.motherPhone && Boolean(row.fatherName),
  })
  return {
    id: row.id, mode: 'shoot', customerNo: row.customerNo, babyName: row.babyName, oopsId: `MOCK-OOPS-${row.customerNo.slice(-3)}`,
    source: row.source, hospital: row.hospital, postnatalCare: row.postnatalCare, additionalSource1: row.additionalSource1, additionalSource2: row.additionalSource2,
    contacts, scheduleId: row.id, scheduleDate: row.scheduleDate, photoStart: row.photoStart, photoEnd: row.photoEnd, scheduleTitle: row.scheduleTitle,
  }
}

export function isLegacySmsPopupSelectionMessage(value: unknown): value is LegacySmsPopupSelectionMessage {
  if (!value || typeof value !== 'object') return false
  const candidate = value as { type?: unknown; recipients?: unknown }
  return (candidate.type === LEGACY_SMS_CUSTOMER_SELECTION || candidate.type === LEGACY_SMS_SHOOT_SELECTION)
    && Array.isArray(candidate.recipients)
}
